import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const StarIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path
        d="M8.38138 1.5403C8.60532 0.982658 9.39474 0.982659 9.61868 1.54031L11.0855 5.19296C11.1808 5.43043 11.4037 5.59236 11.659 5.60967L15.5862 5.87595C16.1857 5.9166 16.4297 6.66739 15.9685 7.05269L12.9479 9.57644C12.7515 9.74051 12.6664 10.0025 12.7288 10.2507L13.6891 14.0679C13.8358 14.6507 13.1971 15.1147 12.6881 14.7952L9.3545 12.7023C9.13777 12.5662 8.86229 12.5662 8.64556 12.7023L5.31191 14.7952C4.80296 15.1147 4.16431 14.6507 4.31092 14.0679L5.27122 10.2507C5.33365 10.0025 5.24852 9.74051 5.05215 9.57644L2.03153 7.05269C1.57038 6.66739 1.81433 5.9166 2.41388 5.87595L6.34103 5.60967C6.59634 5.59236 6.81922 5.43043 6.91458 5.19296L8.38138 1.5403Z"
        stroke={props.color}
        strokeWidth="2"
      />
    </SvgCommon>
  );
};
